
import { Payload, MetadataFormat } from '../services/payload'
import { ZipFile } from '@/services/trim_zip'

import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    zipFile: {
      type: ZipFile,
      required: true
    },
    payload: {
      type: Payload,
      required: true
    }
  },
  data() {
    return {
      MetadataFormat
    }
  },
  computed: {
    isDataWipePackage(): boolean {
      return this.payload.payload_properties.includes("POWERWASH=1");
    },
    otaMetadata(): {
      prefix: string
      key: string
      name: string
    }[] {
      return MetadataFormat.filter(formatter =>
        String((this.payload as any)[formatter.key]).length > 0
      );
    },
    totalCOWSize(): number {
      const cowSizes = this.payload?.manifest?.partitions.map(p => p.estimateCowSize || 0);
      if (!cowSizes) {
        return 0;
      }
      return cowSizes.reduce((a, b) => a + b);
    },
    vabcCompressionParam(): string {
      return this.payload?.manifest?.dynamicPartitionMetadata?.vabcCompressionParam || "";
    },
    securityPatchLevel(): string {
      const spl = this.payload?.manifest?.securityPatchLevel;
      if (!spl) {
        return "";
      }
      return spl;
    },
    totalDynamicPartitionSize(): number {
      const groups = this.payload?.manifest?.dynamicPartitionMetadata?.groups
      if (!groups) {
        return 0
      }
      const dynamicPartitionNamess = new Set(
        groups.flatMap(g => g.partitionNames)
      )
      const dynamicPartitions =
        this.payload.manifest?.partitions.filter(p =>
          dynamicPartitionNamess.has(p.partitionName)
        ) || []
      if (dynamicPartitions.length <= 0) {
        return 0
      }
      return dynamicPartitions
        .map(p => p.newPartitionInfo?.size || 0)
        .reduce((acc, cur) => acc + cur)
    }
  }
})
